import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';

import { Separator } from '../../common/Separator';
import { Comment } from '@models/Comments/CommentModel';
import { CommentView } from './CommentView';
import { CommentList } from '@models/Comments/CommentListModel';
import type { ICommentListStore } from '../CommentList';
import type { CommentInputSizeEnum } from '@components';
import { User } from '@models/Viewer/UserModel';

interface ICommentViewListProps {
  list: CommentList;
  onPressReply(item: Comment): void;
  onPressEdit(item: Comment): void;
  commentListStore: ICommentListStore;
  commentInputSize?: CommentInputSizeEnum;
  onPressUser?(user: User): void;
}

export const CommentViewList = observer<ICommentViewListProps>(
  ({
    list,
    onPressReply,
    onPressEdit,
    commentListStore,
    commentInputSize,
    onPressUser,
  }) => {
    return (
      <Fragment>
        {list.asArray.map((item, index, array) => {
          const isLastItem = array.length === index + 1;

          return (
            <Fragment key={item.id}>
              <CommentView
                item={item.current}
                onPressReply={onPressReply}
                onPressEdit={onPressEdit}
                commentListStore={commentListStore}
                commentInputSize={commentInputSize}
                onPressUser={onPressUser}
              />
              {!isLastItem && <Separator size={['$5', '$6']} />}
            </Fragment>
          );
        })}
      </Fragment>
    );
  },
);
